import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { Field, Textarea } from '@/components/ui/form';
import { Dialog, DialogContent } from '@/components/ui/primitives';
import { cn } from '@/lib/utils';

const COMMON_REASONS = ['מחיר', 'עובדים עם ספק אחר', 'לא רלוונטי לתפריט', 'אין מענה', 'איכות / טעם', 'העסק נסגר'];

export function LostReasonDialog({ open, onOpenChange, onConfirm }: { open: boolean; onOpenChange: (o: boolean) => void; onConfirm: (reason: string | null) => void }) {
  const [reason, setReason] = useState('');
  useEffect(() => {
    if (open) setReason('');
  }, [open]);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent title="סגירת הליד" description="פולואפים פתוחים יבוטלו. הסיבה נשמרת לניתוח עתידי.">
        <div className="flex flex-col gap-4">
          <div className="flex flex-wrap gap-2">
            {COMMON_REASONS.map((r) => (
              <button
                key={r}
                type="button"
                onClick={() => setReason(r)}
                className={cn('rounded-full border px-3 py-1 text-sm', reason === r ? 'border-matcha-600 bg-matcha-50 font-semibold' : 'border-line-strong hover:bg-sunken')}
              >
                {r}
              </button>
            ))}
          </div>
          <Field label="סיבה">{(id) => <Textarea id={id} rows={2} value={reason} onChange={(e) => setReason(e.target.value)} />}</Field>
          <div className="flex justify-end gap-2 border-t border-line pt-4">
            <Button variant="secondary" onClick={() => onOpenChange(false)}>ביטול</Button>
            <Button variant="danger" onClick={() => onConfirm(reason.trim() || null)}>סגירה</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
